import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { AboutSection } from "@/components/AboutSection";
import { WebsiteSubscription } from "@/components/WebsiteSubscription";
import { PricingPlans } from "@/components/PricingPlans";
import { ServicesOrbit } from "@/components/ServicesOrbit";
import { SocialProof } from "@/components/SocialProof";
import { WhyOurModel } from "@/components/WhyOurModel";
import { ProcessSteps } from "@/components/ProcessSteps";
import { References } from "@/components/References";
import { ContactSection } from "@/components/ContactSection";
import { FaqSection } from "@/components/FaqSection";
import { SiteFooter } from "@/components/SiteFooter";
import Datenschutz from "@/pages/Datenschutz";
import Impressum from "@/pages/Impressum";

const Home = () => (
  <main className="min-h-screen bg-background">
    <Navbar />
    <HeroSection />
    <AboutSection />
    <WebsiteSubscription />
    <PricingPlans />
    <ServicesOrbit />
    <SocialProof />
    <WhyOurModel />
    <ProcessSteps />
    <References />
    <ContactSection />
    <FaqSection />
    <SiteFooter />
  </main>
);

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
